import { ErrorElement } from '@frontend/shared/web';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { constants } from '../../constants';
import { AdminRoute } from '../../routes/admin-route';
import { AnonymousLayout } from '../../routes/anonymous-layout';
import { AuthenticatedLayout } from '../../routes/authenticated-layout';
import { DashboardRoute } from '../../routes/dashboard-route';
import { IncidentsRoute } from '../../routes/incidents-route';
import { InvoicesRoute } from '../../routes/invoices-route';
import { LoginRoute } from '../../routes/login-route/LoginRoute';
import { LostFoundRoute } from '../../routes/lost-found-route';
import { NotFoundRoute } from '../../routes/not-found-route/NotFoundRoute';
import { PerformanceRoute } from '../../routes/performance-route';
import { RequirePermission } from '../../routes/RequirePermission';

export const routes = createBrowserRouter(
  [
    {
      element: <AnonymousLayout />,
      errorElement: <ErrorElement />,
      children: [
        { path: 'login', element: <LoginRoute />, errorElement: <ErrorElement /> },
        { path: 'not-found', element: <NotFoundRoute />, errorElement: <ErrorElement /> },
      ],
    },
    {
      element: <AuthenticatedLayout />,
      errorElement: <ErrorElement />,
      children: [
        { path: '/', element: <DashboardRoute />, errorElement: <ErrorElement /> },
        {
          path: 'incidents',
          element: (
            <RequirePermission module="incidents" flag="read">
              <IncidentsRoute />
            </RequirePermission>
          ),
          errorElement: <ErrorElement />,
        },
        {
          path: 'performance',
          element: (
            <RequirePermission module="performance" flag="read">
              <PerformanceRoute />
            </RequirePermission>
          ),
          errorElement: <ErrorElement />,
        },
        {
          path: 'invoices',
          element: (
            <RequirePermission module="invoices" flag="read">
              <InvoicesRoute />
            </RequirePermission>
          ),
          errorElement: <ErrorElement />,
        },
        {
          path: 'lost-found',
          element: (
            <RequirePermission module="lostFound" flag="read">
              <LostFoundRoute />
            </RequirePermission>
          ),
          errorElement: <ErrorElement />,
        },
        {
          path: 'admin',
          element: (
            <RequirePermission module="admin" flag="read">
              <AdminRoute />
            </RequirePermission>
          ),
          errorElement: <ErrorElement />,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/not-found" replace />,
    },
  ],
  {
    basename: constants.basename,
  },
);
